"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var pharmacy_selector_1 = require("../../../components/pricing/pharmacy-selector/pharmacy-selector");

var price_lookup_1 = require("../../../components/pricing/price-lookup/price-lookup");

var pricing_header_1 = require("../../../components/pricing/pricing-header/pricing-header");

var pricing_rule_selector_1 = require("../../../components/pricing/pricing-rule-selector/pricing-rule-selector");

var rule_details_1 = require("../../../components/pricing/rule-details/rule-details");

var theme_pricing_system_1 = require("../../../theming/theme.pricing-system");

var PharmacyPricingScreen = function (_super) {
  __extends(PharmacyPricingScreen, _super);

  function PharmacyPricingScreen() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PharmacyPricingScreen.prototype.render = function () {
    var _this = this;

    return react_1.default.createElement(react_native_1.View, {
      style: theme_pricing_system_1.pricingStyles.pageScrollView
    }, react_1.default.createElement(pricing_header_1.PricingHeader, null), react_1.default.createElement(react_native_1.View, {
      style: styles.flexRow
    }, react_1.default.createElement(pharmacy_selector_1.PharmacySelector, {
      selectedPharmacyId: this.props.selectedPharmacyId,
      onChangePharmacy: this.props.pricingPharmacyGroupSelectAction,
      pharmacyList: this.props.pharmacies
    }), react_1.default.createElement(pricing_rule_selector_1.PricingRuleSelector, {
      pricingRulesList: this.props.pricingRules,
      selectedPricingRuleId: this.props.selectedRuleId,
      onChangePricingRule: this.props.pricingRuleSelectAction
    })), react_1.default.createElement(react_native_1.View, {
      style: styles.flexRow
    }, this.props.selectedRuleId ? react_1.default.createElement(rule_details_1.RuleDetailsView, {
      id: this.props.selectedRuleId,
      selectedTemplate: this.props.pricingRules.find(function (rule) {
        return rule.id === _this.props.selectedRuleId;
      }).template
    }) : undefined), react_1.default.createElement(react_native_1.View, {
      style: styles.flexRow
    }, react_1.default.createElement(price_lookup_1.PriceLookupView, null)));
  };

  return PharmacyPricingScreen;
}(react_1.default.Component);

exports.PharmacyPricingScreen = PharmacyPricingScreen;
var flexRow = {
  alignItems: 'flex-start',
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  paddingHorizontal: 20,
  paddingVertical: 10
};
var styles = react_native_1.StyleSheet.create({
  flexRow: flexRow
});